import { useState, useRef, useEffect } from 'react'
import './FloorFilter.css'

const DEFAULT_FLOORS = [
  { id: 1, label: 'Tầng 1' },
  { id: 2, label: 'Tầng 2' },
  { id: 3, label: 'Tầng 3' },
  { id: 4, label: 'Tầng 4' },
  { id: 5, label: 'Tầng 5' },
  { id: 6, label: 'Tầng 6' },
  { id: 7, label: 'Tầng 7' },

]

/**
 * FloorFilter — bộ lọc mặt bằng theo tầng
 * @param {Array}    floors        - danh sách tầng [{ id, label }]
 * @param {number}   activeFloor   - id tầng đang chọn (controlled)
 * @param {Function} onFloorChange - callback khi chọn tầng
 */
function FloorFilter({ floors = DEFAULT_FLOORS, activeFloor, onFloorChange }) {
  const [internalActive, setInternalActive] = useState(floors[0]?.id ?? null)

  const selected = activeFloor ?? internalActive
  const listRef = useRef(null)
  const activeIndex = floors.findIndex(({ id }) => id === selected)

  const handleSelect = (id) => {
    setInternalActive(id)
    onFloorChange?.(id)
  }

  useEffect(() => {
    if (!window.matchMedia('(max-width: 767px)').matches) return
    const activeEl = listRef.current?.querySelector('.floor-filter__btn--active')
    activeEl?.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' })
  }, [selected])

  return (
    <div className="floor-filter" role="navigation" aria-label="Lọc theo tầng">
      {/* Title */}
      <h3 className="floor-filter__title">Mặt Bằng Tầng</h3>

      <button
        type="button"
        className={`floor-filter__nav floor-filter__nav--prev${activeIndex <= 0 ? ' floor-filter__nav--disabled' : ''}`}
        aria-label="Tầng trước"
        aria-disabled={activeIndex <= 0}
        disabled={activeIndex <= 0}
        onClick={() => {
          if (activeIndex > 0) handleSelect(floors[activeIndex - 1].id)
        }}
      >
        <svg className="floor-filter__nav-icon" viewBox="0 0 24 24" aria-hidden="true">
          <path d="M15 6l-6 6 6 6" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </button>

      <div className="floor-filter__track">
        <ul className="floor-filter__list" role="list" ref={listRef}>
          {floors.map(({ id, label }) => {
            const isActive = selected === id
            return (
              <li key={id} className="floor-filter__item">
                <button
                  id={`floor-btn-${id}`}
                  type="button"
                  className={`floor-filter__btn${isActive ? ' floor-filter__btn--active' : ''}`}
                  aria-pressed={isActive}
                  onClick={() => handleSelect(id)}
                >
                  {label}
                </button>
              </li>
            )
          })}
        </ul>
      </div>

      <button
        type="button"
        className={`floor-filter__nav floor-filter__nav--next${activeIndex < 0 || activeIndex >= floors.length - 1 ? ' floor-filter__nav--disabled' : ''}`}
        aria-label="Tầng sau"
        aria-disabled={activeIndex < 0 || activeIndex >= floors.length - 1}
        disabled={activeIndex < 0 || activeIndex >= floors.length - 1}
        onClick={() => {
          if (activeIndex >= 0 && activeIndex < floors.length - 1) {
            handleSelect(floors[activeIndex + 1].id)
          }
        }}
      >
        <svg className="floor-filter__nav-icon" viewBox="0 0 24 24" aria-hidden="true">
          <path d="M9 6l6 6-6 6" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </button>
    </div>
  )
}

export default FloorFilter
